import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Table, Row, Form, FormField, Checkbox, Col, Button } from "elemental-react16"
import { withRouter } from "react-router"
import "style/CheckoutPage.scss"
import Price from "components/Price/Price"
import { FrachtRow } from "theme/sandra/components/Cart/CartTotal"
import { translate } from "translate"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import { Icon, Message } from "semantic-ui-react"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReadOnly"
import track from "shop/track"

@withRouter
class ConfirmationPage extends Component {
  constructor() {
    super()
    this.state = {
      show   : false,
      cart   : shop.cart,
      agb    : false,
      privacy: false
    }
    shop.cart.hooks.changed.add( this.update )
  }

  update = ( cart ) => {
    this.setState( { cart } )
  }

  componentDidMount() {
    track.checkout( { step: 3, products: shop.cart.products } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.update )
  }

  handleEnquiry = () => {
    shop.cart.setExtra( "is_quotation_request", true )
    this.props.history.push( "../success/" )
  }

  handleSubmit = () => {
    shop.cart.setExtra( "is_quotation_request", false )
    this.props.history.push( "../success/" )
  }

  handleAgb = ( agb ) => {
    console.log( `agb`, agb )
    this.setState( { agb } )
  }

  handleDatenschutz( privacy ) {
    this.setState( { privacy } )
  }

  toHome = () => {
    this.props.history.push( "/home" )
  }

  render() {
    let { agb, privacy } = this.state

    let manual_order_id = shop.cart.getExtra( "manual_order_id" )
    let attachments = shop.cart.getExtra( "attachments" )
    let { comment, deliveraddress, deliverdate } = shop.cart.data
    let billingAddress = shop.session.value
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const { hasDeliveryAddress } = shop.cart
    return (
      <div className="pb4">
        <HeaderCheckout activeStep={2}/>

        <div className="container ">
          {/*<Link to="/checkout/delivery"> <Button > <i className="icon-angle-left"/> Zurück </Button></Link>*/}
          <section>

            <div className="row-title tl">
              <h2>{translate( "your data" )}</h2>
            </div>

            <div className="pb3">
              <Row>
                {(manual_order_id !== undefined) &&
                <Col md="1/5" className=""><span className="black-50">{translate( "manual_order_id" )}</span>
                  <div className="pt3">
                    <p className="mb4">{manual_order_id}</p>
                  </div>
                </Col>}
                <Col md="1/5" className=""><span className="black-50">{translate( "billing address" )} </span>
                  <div className="pt3">
                    <strong> {billingAddress.title}</strong> <br/>
                    {billingAddress.street} <br/>
                    {billingAddress.pcode} {billingAddress.city}<br/>
                    {billingAddress.country}<br/>
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "delivery address" )} </span>
                  <div className="pt3">
                    {!hasDeliveryAddress && <div className={"b"}>{translate( "billing address" )}</div>}
                    {deliveraddress && <div className="mb4">
                      <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                      {deliveraddress.street}<br/>
                      {deliveraddress.pcode} {deliveraddress.city}<br/>
                      {deliveraddress.country}<br/>
                    </div>
                    }
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "payment" )}</span>
                  <div className="pt3">
                    <strong>{translate( "as agreed on" )}</strong>
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "your comment" )}
                  <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>


                {deliverdate &&
                <Col md="1/5" className=""><span className="black-50">{translate( "delivery after" )}
                  <div className="pt3">
                  <p className="mb4">{deliverdate}</p>
              </div>
              </span></Col>}

              </Row>
            </div>

          </section>


          <section>

            {attachments && <Row>
              <Col>
                <div className="row-title tl">
                  <h2>{translate( "attachments" )}</h2>
                </div>
                <p><strong>Logo ID</strong>: {attachments}</p>
              </Col>
            </Row>}
          </section>

          <section className="overflow-hidden">
            <div className="row-title tl">
              <h2>{translate( "order items" )}</h2>
            </div>

            <ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()}/>
            <Table style={{ maxWidth: "320px" }} className="fr">
              <thead>

              <tr>
                <td className="tr" colSpan="2">
                  <span
                    className="black-50 f5"><strong>{shop.cart.size} {translate( "positions" )} / {shop.cart.count} Artikel</strong></span>
                </td>
              </tr>

              <tr>
                <td><span className="f5 b black">{translate( "Zwischensumme" )}</span></td>
                <td className="f4  black tr"><Price>{shop.cart.sum}</Price></td>
              </tr>

              <FrachtRow sum={shop.cart.sum}/>




              {/* DISCOUNTS!*/}
              {(shop.session.handId && !!shop.cart.sumDiscount) &&
              <React.Fragment>
                <tr className={"black-60 f5"}>
                  <td>{translate( "Discount" )}</td>
                  <td className="tr"><Price>{shop.cart.sumDiscount}</Price></td>
                </tr>

                <tr>
                  <td><strong>{translate( "nach Rabatt" )}</strong></td>
                  <td className="tr"><Price>{shop.cart.sum - shop.cart.sumDiscount}</Price></td>
                </tr>
              </React.Fragment>
              }


              </thead>
            </Table>
            <br/>
          </section>

          <section>
            <div className="row-title tl">
              <h2>{translate( "Abschluss" )}</h2>
            </div>

            <div className="tr">
              <Form type="horizontal">
                <FormField>
                  <div className="tr"><Link target="_blank"
                                            to="/cms/agb">{translate( "AGB" )}</Link><br/></div>

                  <Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked )}
                            label={translate( "I accept the general terms and conditions" )}/>
                </FormField>

                <FormField>
                  <div className="tr"><Link target="_blank"
                                            to="/cms/datenschutz">{translate( "Datenschutzerklärung" )}</Link><br/>
                  </div>
                  <Checkbox value={privacy}
                            onChange={( e ) => this.handleDatenschutz( e.target.checked )}
                            label={translate( "privacy_notice_notice" )}/>
                </FormField>
              </Form>
            </div>

            {shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
            <div className="cf pb2">
              <Message negative className="">
                <div className="total ">
                  <div className="ph3">
                    <Icon name="info"/>{translate( "minimum order value not reached" )}
                    <span className="pull-right">
                    <Price>{shop.config.MIN_ORDER_VALUE}</Price>
                  </span>
                  </div>
                </div>
              </Message>
            </div>
            }
            {!agb && <div className="cf pb2">
              <Message negative className="">
                <div className="total ">
                  <div className="ph3">
                    <Icon name="info"/>{translate( "please confirm our general terms" )}
                  </div>
                </div>
              </Message>
            </div>}
            {!privacy && <div className="cf pb2">
              <Message negative className="">
                <div className="total ">
                  <div className="ph3">
                    <Icon name="info"/>{translate( "please confirm our privacy information" )}
                  </div>
                </div>
              </Message>
            </div>}

            {!isRequest &&
            <Button
              className="fr"
              disabled={!agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE}
              type="primary"
              onClick={this.handleSubmit}
              style={{
                paddingLeft : "32px",
                paddingRight: "32px"
              }}>{translate( "order now" )}</Button>}

            {isRequest &&
            <Button
              className="fr"
              type="primary"
              disabled={!agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE}
              onClick={this.handleEnquiry}
              style={{
                paddingLeft : "32px",
                paddingRight: "32px"
              }}>{translate( "send enquiry" )}</Button>}
          </section>
        </div>
      </div>

    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product )
export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/theme/sandra/pages/checkout/ConfirmationPage.js